module.exports = __webpack_public_path__ + "dzlogo.png?bc13f5a5ac19fd43cd38aa58a6b640da";


//////////////////
// WEBPACK FOOTER
// ./static/assets/dzlogo.png
// module id = 528
// module chunks = 0